import { TASK_DETAIL } from './types';

export const setTaskDetailResMsg = (payload) => {
  const { success, error, title, footer } = payload;
  const resObj = {
    success: success || '',
    error: error || '',
    title: title || '',
    footer: footer || ''
  };
  return {
    type: TASK_DETAIL.SET_RES_MSG,
    payload: resObj
  };
};

export const setCurrentTask = (payload) => {
  return {
    type: TASK_DETAIL.SET_TASK,
    payload
  };
};

export const setTpInfoVisible = (payload) => {
  return {
    type: TASK_DETAIL.SET_TP_INFO_VISIBLE,
    payload
  };
};

export const setSubstagesVisible = (payload) => {
  return {
    type: TASK_DETAIL.SET_SUBSTAGES_VISIBLE,
    payload
  };
};

export const setOpsInfoVisible = (payload) => {
  return {
    type: TASK_DETAIL.SET_OPS_INFO_VISIBLE,
    payload
  };
};

export const setModalType = (payload) => {
  return {
    type: TASK_DETAIL.SET_MODAL_TYPE,
    payload
  };
};
